import { createContext, ReactNode, useContext } from 'react';
type RecordLookNavigation = (lookId: string, lookViewportTop: number) => void;
const LookNavigationRestorationContext = createContext<RecordLookNavigation | null>(null);
export const LookNavigationRestorationProvider = ({
  children,
  recordLookNavigation
}: {
  children: ReactNode;
  recordLookNavigation: RecordLookNavigation;
}) => <LookNavigationRestorationContext.Provider value={recordLookNavigation}>
    {children}
  </LookNavigationRestorationContext.Provider>;
export const useLookNavigationRestoration = () => useContext(LookNavigationRestorationContext);